import * as yup from "yup";
import { TFunction } from "i18next";

export const getYupSchemaForRatingVersionForm = (t: TFunction) => {
  return yup.object().shape({
    year: yup
      .number()
      .nullable()
      .typeError(t("validation.numeric_field"))
      .integer(t("validation.integer")),
    IndicatorId: yup
      .number()
      .nullable()
      .typeError(t("validation.numeric_field"))
      .integer(t("validation.integer")),
    IndicatorGroupId: yup
      .number()
      .nullable()
      .typeError(t("validation.numeric_field"))
      .integer(t("validation.integer")),
  });
};
